import { render, staticRenderFns } from "./DistrictCreateModal.vue?vue&type=template&id=0c8ee26b&"
import script from "./DistrictCreateModal.vue?vue&type=script&lang=js&"
export * from "./DistrictCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports